/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUploadUrlQueryVariables = Exact<{
  fileType: string;
  fileOriginalName: string;
  pathId: string;
}>;


export type GetUploadUrlQuery = { getUploadUrl: { uploadUrl: string } | null };


export const GetUploadUrlDocument = /*#__PURE__*/ gql`
    query GetUploadUrl($fileType: String!, $fileOriginalName: String!, $pathId: uuid!) {
  getUploadUrl(
    fileType: $fileType
    fileOriginalName: $fileOriginalName
    pathId: $pathId
  ) {
    uploadUrl
  }
}
    `;

/**
 * __useGetUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadUrlQuery({
 *   variables: {
 *      fileType: // value for 'fileType'
 *      fileOriginalName: // value for 'fileOriginalName'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useGetUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables> & ({ variables: GetUploadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
      }
export function useGetUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
        }
// @ts-ignore
export function useGetUploadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadUrlQuery, GetUploadUrlQueryVariables>;
export function useGetUploadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadUrlQuery | undefined, GetUploadUrlQueryVariables>;
export function useGetUploadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
        }
export type GetUploadUrlQueryHookResult = ReturnType<typeof useGetUploadUrlQuery>;
export type GetUploadUrlLazyQueryHookResult = ReturnType<typeof useGetUploadUrlLazyQuery>;
export type GetUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetUploadUrlSuspenseQuery>;
export type GetUploadUrlQueryResult = Apollo.QueryResult<GetUploadUrlQuery, GetUploadUrlQueryVariables>;